__webpack_require__.p = "/internship/Thando-portfolio/";